import React from "react";
import { PieChart } from "react-minimal-pie-chart";
import "./styles.scss";

class Splash extends React.PureComponent {
  state = {};
  render() {
    return (
      <div className="loading-container" style={this.props.style}>
        {/* <img className="loading-background" src={require("static/images/splash.png")} alt="" /> */}
        <img className="loading-logo" src={require("../../static/images/splash-icon.png")} alt="" />
        <PieChart
          className="loading-chart"
          radius={40}
          startAngle={-90}
          data={[
            {
              title: "One",
              value: this.props.loaded,
              color: "#fff",
            },
            {
              title: "Two",
              value: this.props.totalLoading - this.props.loaded,
              color: "transparent",
            },
          ]}
          lineWidth={20}
          rounded
        />
      </div>
    );
  }
}

export default Splash;
